import { ResHelper } from '@/helper/ResHelper';

export function localizeWithFallback(key: string, fallback: string): string {
    if (!key) {
        return '';
    }

    return ResHelper.getStringOrFallback(key, fallback);
}
